export default __webpack_public_path__ + "static/media/breakfast_2.a4fd269c.jpg";